/**
 * URLs for the font files the first screen paints in.
 *
 * `@font-face` rules are only discoverable once the stylesheet has downloaded
 * and parsed, which puts the font files a full round trip late on the critical
 * path. Exporting the hashed URLs lets an app preload them in its document head
 * alongside the CSS instead of after it.
 *
 * Only the Latin faces are here: those are the ones every page actually paints.
 * The rest of the subsets stay lazily discovered through the stylesheet, which
 * is the correct behaviour for a glyph range no page has asked for yet.
 */
import instrumentSerifLatin from "@fontsource/instrument-serif/files/instrument-serif-latin-400-normal.woff2?url";
import interLatin from "@fontsource-variable/inter/files/inter-latin-wght-normal.woff2?url";

/** Body text — "Inter Variable", the `--font-sans` face. */
export const INTER_LATIN_URL: string = interLatin;

/** Headings — "Instrument Serif", the `--font-heading` face. */
export const INSTRUMENT_SERIF_LATIN_URL: string = instrumentSerifLatin;

/** Both, in the order a page paints them. */
export const PRELOADED_FONT_URLS: readonly string[] = [
  INTER_LATIN_URL,
  INSTRUMENT_SERIF_LATIN_URL,
];
